class DamagedArticleStockRequest {
    public to: string;
    public articleId: string;
    public amount: number;
    public comment?: string;

    constructor(to: string, articleId: string, amount: number, comment?: string) {
        this.to = to;
        this.articleId = articleId;
        this.amount = amount;
        this.comment = comment;
    }
}

export default DamagedArticleStockRequest;
